import { render, staticRenderFns } from "./VDataTablePlus.vue?vue&type=template&id=b4118f64&scoped=true"
import script from "./VDataTablePlus.vue?vue&type=script&lang=js"
export * from "./VDataTablePlus.vue?vue&type=script&lang=js"
import style0 from "./VDataTablePlus.vue?vue&type=style&index=0&id=b4118f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4118f64",
  null
  
)

export default component.exports